document.addEventListener('alpine:init', () => {
    Alpine.data('eixosLabcdBlock', () => ({
        activeEixo: 0, // 0 means none or default
        setActive(index) {
            this.activeEixo = index;
        },
        clearActive() {
            this.activeEixo = 0;
        }
    }));
});
